import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ComingSoonLabelComponent } from '../components';

@Component({
  selector: 'rp-home-handy-tools-schema',
  standalone: true,
  templateUrl: './handy-tools-schema.component.html',
  styleUrl: './../schema.base.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, ComingSoonLabelComponent],
})
export class HandyToolsSchemaComponent {}
